
import { reactive } from "vue";

import ConfigurationModel from "@/models/ConfigurationModel";
import TenantConfigLoader from "@/models/TenantConfigLoader";
/**
 * Application configuration manager class
 */
class AppConfig{
    constructor(){
        this.isLoaded = false;
        this.tenant = this.#_createReactiveState( {} );
        this.token = "";
        this.user = {};
    }

    setUser( token, user ){
        this.token = token;
        this.user = user;
    }

    #_createReactiveState( state = {} ){
        this._defaultState = JSON.parse( JSON.stringify( state ) );

        const handler = {
            get: ( target, key ) => target[key],
            set: ( target, key, value ) => {
                target[key] = value;

                return true;
            }
        };

        return reactive( new Proxy( state, handler ) );
    }

    /**
     * Initialize the configuration
     */
    async init( tenantConfiguration ){
        if ( !this.isLoaded ){
            await this.#loadTenantAppConfig( tenantConfiguration );
        }

        if ( Object.keys( tenantConfiguration )?.length ){
            await this.#loadTenantAppConfig( tenantConfiguration );
        }

        return;
    }

    /**
     * Load tenant application configuration
     */
    async #loadTenantAppConfig( config = {}, retry = 0 ){
        // Check if a valid configuration object is provided
        const hasConfig = !!( config && typeof config === "object" && Object.keys( config )?.length );

        try {
            const site_config = hasConfig ? config : {};

            if ( !hasConfig ){
                const appConfig = await TenantConfigLoader.initialConfigLoader();

                Object.assign( site_config, appConfig );
            }

            if ( !site_config || typeof site_config !== "object" ){
                throw new Error( "Invalid site configuration loaded" );
            }

            // Set the tenant configuration object and mark as loaded
            this.tenant = new ConfigurationModel( site_config );
            this.tenant.loadConfiguration( site_config );
            // Validate the tenant configuration object
            if ( !this.tenant || typeof this.tenant !== "object" ){
                throw new Error( "Invalid tenant configuration" );
            }

            this.isLoaded = true;
        } catch ( error ){
            if ( !retry ){
                TenantConfigLoader.clearCacheConfig();

                return this.#loadTenantAppConfig( config, retry++ );
            }

            throw new Error( "Unable to retrieve configuration", error );
        }
    }
}

// Create singleton instance
const APP_CONFIG = new AppConfig();

export default APP_CONFIG;